import * as _ from "lodash"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_PeriodTypeRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Period_Type} from "../PA.Core/PAdbSchema";
import {PeriodTypeBO} from "./PeriodTypeBO";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class PeriodTypeBOValidations {

    static async ValidateFields(aBO: PeriodTypeBO): Promise<void> {
        const self = this;
        let dbContext = new PAdbContext({})
        let rowPresent: any = {}
        let userContext = PAEnvironment.getValue(PAEnvironment.UserContext, 'UserContext')
        let bHasRole = userContext.hasRoleId("Period_Data_Editor")

        if (_.isEmpty(aBO.WB_PeriodType.cif.PERIOD_TYPE_ID) && _.isEmpty(aBO.WB_PeriodType.cif.PERIOD_TYPE_NAME) && !bHasRole){
            self.addMessage(aBO, "viewerRoleCreate", 'Only Users with Editor Role can Create a new Period Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleCreate")
        }

        if(!bHasRole){
            self.addMessage(aBO, "viewerRoleSave", 'Only Users with Editor Role can update a Period Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleSave")
        }

        if (_.isEmpty(aBO.WB_PeriodType.cif.PERIOD_TYPE_ID))
        {
            self.addMessage(aBO, "emptyID", 'Period ID cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyID")
        if (_.isEmpty(aBO.WB_PeriodType.cif.PERIOD_TYPE_NAME))
        {
            self.addMessage(aBO, "emptyName", 'Period Name cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyName")


        //Empty MD Set
        if(aBO.WB_PeriodType.cif.WB_MDSET_ID===0){
            self.addMessage(aBO, "emptyMDSet", 'MD Set cannot be empty')
        }
        else{
            aBO.ValidateMessageProvider.removeMessage("emptyMDSet")
        }

        // Period Types are considered duplicates only within the same Master Data Set
        let periodTypeRows: WB_PeriodTypeRow[] = await dbContext.findAll(esWB_Period_Type,
            {where: {DELETED_IND: {neq: '1'},
                    WB_PERIODM_ID: {neq: aBO.WB_PeriodType.cif.WB_PERIODM_ID},
                    WB_MDSET_ID: aBO.WB_PeriodType.cif.WB_MDSET_ID,
                    PERIOD_TYPE_ID: aBO.WB_PeriodType.cif.PERIOD_TYPE_ID}})

        //Duplicate ID/Name combo
        let periodTypeRowsIDName: WB_PeriodTypeRow[] = await dbContext.findAll(esWB_Period_Type,
            {where: {DELETED_IND: {neq: '1'},
                    WB_PERIODM_ID: {neq: aBO.WB_PeriodType.cif.WB_PERIODM_ID},
                    WB_MDSET_ID: aBO.WB_PeriodType.cif.WB_MDSET_ID,
                    PERIOD_TYPE_ID: aBO.WB_PeriodType.cif.PERIOD_TYPE_ID,
                    PERIOD_TYPE_NAME: aBO.WB_PeriodType.cif.PERIOD_TYPE_NAME,
                }})
        if (!_.isEmpty(periodTypeRowsIDName)) {
            self.addMessage(aBO, "duplicateIDName", 'Existing Period Type(s) with the same ID and Name: ' +
                '\nPeriod Types: ' + _.map(periodTypeRowsIDName, (a) => `${a.cif.PERIOD_TYPE_NAME} (${a.cif.PERIOD_TYPE_ID})`).join(",")
            )
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateIDName")
        }

        if (!_.isEmpty(periodTypeRows)) {
            self.addMessage(aBO, "duplicateID", 'Existing Period Type(s) with the same ID: ' +
                '\nPeriod Types: ' + _.map(periodTypeRows, (a) => `${a.cif.PERIOD_TYPE_NAME} (${a.cif.PERIOD_TYPE_ID})`).join(",")
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }

    }

    private static addMessage(aBO: PeriodTypeBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}